import { useDispatch } from 'react-redux';
import { Draggable } from 'react-beautiful-dnd';
import Swal from 'sweetalert2';

import { setBlockInEdition } from '../../../../actions/admin/blog';

import {
    Grid, Paper, IconButton
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

const DraggableCol = ({ col_index, row_index, col, setOpen, row, setRow }) => {
    const dispatch = useDispatch();
    const { id, item, xs, md } = col;
    
    const handleClickOpen = () => {
        dispatch(setBlockInEdition({ ...col, row_index }));
        setOpen(true);
    };

    const deleteBlock = () => {
        Swal.fire({
            title: '¿Eliminar el bloque?',
            showDenyButton: true,
            confirmButtonText: 'Si',
            denyButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                setRow(e => e.map((row, index) =>
                    index === row_index ? // fila actual, se retirá bloque
                        {
                            ...row,
                            col: row.col.filter(u => u.id !== id)
                        }
                    : row // las demás filas sin cambios
                ));
            }
        });
    };

    const moveBlock = (new_index) => () => {
        setRow(e => e.map((e_row, index) => {
            // validar índices
            if (row_index < 0 || row_index >= e_row.length) return e_row;
            if (new_index < 0 || new_index >= e_row.length) return e_row;

            // bloque ya está en la fila destino, no hacer nada
            if (new_index === row_index) return e_row;

            if (index === row_index) // fila actual, se retirá bloque
                return {
                    ...e_row,
                    col: e_row.col.filter(u => u.id !== id)
                };

            if (index === new_index) // nueva fila, se inserta bloque
                return {
                    ...e_row,
                    col: [...e_row.col, col]
                };

            return e_row; // las demás filas sin cambios
        }));
    };

    return (
        <Draggable draggableId={id} index={col_index}>
            {(provided) => (
                <Grid item xs={xs} md={md}
                    ref={ provided.innerRef }
                    { ...provided.draggableProps }
                    { ...provided.dragHandleProps }>
                    <Paper square sx={{ p: 1, boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)' }}>
                        <div dangerouslySetInnerHTML={{ __html: item }}></div>
                        <IconButton aria-label="update"
                            onClick={ handleClickOpen }>
                            <EditIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton aria-label="delete"
                            onClick={ deleteBlock }>
                            <DeleteIcon fontSize="inherit" />
                        </IconButton>
                        {
                            row_index > 0 &&
                                <IconButton aria-label="move-up"
                                    onClick={ moveBlock(row_index - 1) }>
                                    <ArrowCircleUpIcon fontSize="inherit" />
                                </IconButton>
                        }
                        {
                            row_index < row.length - 1 &&
                                <IconButton aria-label="move-down"
                                    onClick={ moveBlock(row_index + 1) }>
                                    <ArrowCircleDownIcon fontSize="inherit" />
                                </IconButton>
                            }
                    </Paper>
                </Grid>
            )}
        </Draggable>
    );
};

export default DraggableCol;